import { LanguageProvider } from './LanguageProvider'

export default LanguageProvider
